import { boolean, object, string, InferType, array, number } from 'yup'
import { snsInfoSchema } from './snsInfoSchema'

export const playlistFormSchema = object({
  name: string().required('リストの名前は必須です。').default(''),
  published: boolean().default(false),
  snsInfo: snsInfoSchema,
  quizIds: array(string()).default([]),
  imageUrl: string().default(''),
  description: string().default(''),
  passingScore: number().transform((currentValue, originalValue) =>
    originalValue === null ? 0 : currentValue
  ),
  passText: string().ensure().default(''),
  failText: string().ensure().default(''),
}).defined()

export type PlaylistFormValues = InferType<typeof playlistFormSchema>
